import { $host, $authHost, isDev } from './index'
import { jwtDecode } from 'jwt-decode'
import { httpPoint } from '../utils/const'

export const signin = async (login, password) => {
    const { data } = await $host.post(httpPoint.user + 'login', { login, password })
    return data
}

export const registration = async (login, password, email, type, timezone, rules) => {
    const { data } = await $host.post(httpPoint.user + 'registration', { login, password, email, type, timezone, rules })
    return data
}

export const check = async () => {
    if (localStorage.getItem('token')) {
        const { data } = await $authHost.post(httpPoint.user + 'auth')
        localStorage.setItem('token', data.token)
        return data
    }
}

export const updateAvatar = async (formData) => {
    const { data } = await $authHost.post(httpPoint.user + 'update-avatar', formData);
    return data
}

export const removeAvatar = async () => {
    const { data } = await $authHost.post(httpPoint.user + 'remove-avatar');
    return data
}

export const getUserInfo = async () => {
    const { data } = await $authHost.post(httpPoint.user + 'info');
    return data
}

export const upUserInfo = async (payload) => {
    const { data } = await $authHost.post(httpPoint.user + 'update-info', payload);
    return data
}

